// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-section-wrap {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
}

.map-preview-console {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/MapPreviewSection/MapPreviewSection.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".map-section-wrap {\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 0 24px;\n  box-sizing: border-box;\n}\n\n.map-preview-console {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
